import { FC } from 'react';

export const Root: FC = () => {
  return null;
};
